module.exports = __webpack_public_path__ + "img/Curve.050a40e7.png";